/* eslint-disable no-unused-vars */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LiquidationsPageComponent } from './pages';

const routes: Routes = [
  {
    path: '',
    component: LiquidationsPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LiquidationsRoutingModule {}
